// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RZt2","colBig":"styles_colBig__1JnJw","colSmall":"styles_colSmall__3H-r_","shopifyNameWrapper":"styles_shopifyNameWrapper__zLSB5"};